import React from 'react';

const DevisPage = () => <h1>Faire un Devis Page</h1>;

export default DevisPage;
